<template>
  <b-select
    v-model="localValue"
    @input="$emit('input', localValue)"
    :loading="types.loading"
    expanded
  >
    <option
      v-for="(type, index) in types.data"
      :key="index"
      :value="type.id"
    >{{ type.id }} - {{ type.frequency }} ({{ type.issue_activation_type }})</option>
  </b-select>
</template>


<script>
export default {
  props: {
    type: String,

    value: null
  },

  data() {
    return {
      localValue: this.value,

      types: new window.RemoteCollection(
        "/admin/api/magazine/subscription-plan-types?filter[withoutGold]=true"
      )
    };
  },

  created() {
    this.types.load();
  }
};
</script>
